import React, { useState } from "react";
import { styled } from "@mui/material/styles";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';

const CustomDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiPaper-root": {
    maxWidth: "unset", // Removes default max-width limit of the modal
    maxHeight: "90vh", // Ensures the dialog doesn't exceed viewport height
    overflow: "visible", // Avoids unwanted scrollbars inside the modal
  },
  "& .MuiDialogActions-root": {
    // padding: theme.spacing(1),
  },
}));

export default function CustomModal({ open, header, body, handleClose,noPadding ,width}) {
  
  const customDialogClose=(event,reason)=>{
    if(reason==='backdropClick') return;
    handleClose();
  }

  return (
    <>
      <CustomDialog
        onClose={customDialogClose}
        aria-labelledby="customized-dialog-title"
        open={open}
        disableEscapeKeyDown
        sx={{
          "& .MuiDialogContent-root": {
            padding: `${noPadding ==='true'?'10px':'30px'}`,
            overflow:'auto'
          },
          "& .MuiPaper-root": {
            width: width ? width : "auto", // Automatically adjusts width based on content
          },
        }}
      >
        <div style={{backgroundColor:"#067de2",color:"white",display:'flex',justifyContent:'space-between',alignItems:"center"}}>
          <DialogTitle sx={{ m: 0, py: 2,fontFamily:'proxima-semibold' }} id="customized-dialog-title">
            {header ? header : ""}
          </DialogTitle>
          <div style={{paddingRight:'18px',}}>
            <CancelOutlinedIcon
              aria-label="close"
              onClick={handleClose}
              sx={(theme) => ({
                fontSize:"28x",
                cursor:'pointer'
              })}
            />
          </div>
        </div>
        <DialogContent dividers>
          {body?body:'Enter some content'}
        </DialogContent>
      </CustomDialog>
    </>
  );
}
